// src/components/FAQ.jsx
import React, { useState } from 'react';
import { useTranslation } from '../context/AppContext';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const questions = [
    {
      question: t.faq1,
      answer: t.faq1Answer,
    },
    {
      question: t.faq2,
      answer: t.faq2Answer,
    },
    {
      question: t.faq3,
      answer: t.faq3Answer,
    },
    {
      question: t.faq4,
      answer: t.faq4Answer,
    },
  ];

  return (
    <section className="py-16 px-6 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 dark:text-white">{t.faqTitle}</h2>
        <div className="space-y-4">
          {questions.map((item, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-700 rounded-xl shadow-sm hover:shadow-md transition overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 text-left font-semibold text-gray-800 dark:text-gray-200 flex justify-between items-center focus:outline-none"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
              >
                <span>{item.question}</span>
                <span className="text-2xl transition-transform duration-300" style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0)' }}>
                  ▼
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{
                  maxHeight: openIndex === index ? '500px' : '0',
                  opacity: openIndex === index ? 1 : 0,
                }}
              >
                <div className="px-6 pb-4 text-gray-600 dark:text-gray-300">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}